const depreciationEndpoints = {
  depreciations: (companyId: string, investmentId: number) =>
    `/companies/${companyId}/budgeting/investments/${investmentId}/deprecations` as const,
  corrections: (companyId: string, investmentId: number) =>
    `/companies/${companyId}/budgeting/investments/${investmentId}/corrections` as const
}

export default depreciationEndpoints
